import { applyPreferences, getPreferences, preferenceDefaults, savePreferences } from '@/utils/preferences'
import { getMenuVisibilityConfig } from '@/api/static-data'

const state = {
  preferences: getPreferences(),
  globalLoading: false,
  menuVisibility: {}
}

const mutations = {
  SET_GLOBAL_LOADING(state, value) {
    state.globalLoading = !!value
  },
  TOGGLE_SIDEBAR(state) {
    state.preferences = savePreferences({ sidebarCollapsed: !state.preferences.sidebarCollapsed })
    applyPreferences(state.preferences)
  },
  CLOSE_SIDEBAR(state) {
    state.preferences = savePreferences({ sidebarCollapsed: true })
    applyPreferences(state.preferences)
  },
  SET_PREFERENCE(state, { key, value }) {
    state.preferences = savePreferences({ [key]: value })
    applyPreferences(state.preferences)
  },
  SET_PREFERENCES(state, preferences) {
    state.preferences = savePreferences(preferences)
    applyPreferences(state.preferences)
  },
  RESET_PREFERENCES(state) {
    state.preferences = savePreferences(preferenceDefaults)
    applyPreferences(state.preferences)
  },
  SET_MENU_VISIBILITY(state, value) {
    state.menuVisibility = value || {}
  }
}

const actions = {
  loadMenuVisibility({ commit }) {
    return getMenuVisibilityConfig()
      .then(items => {
        const visibility = items.reduce((result, item) => {
          result[item.path] = item.visible
          return result
        }, {})
        commit('SET_MENU_VISIBILITY', visibility)
        return visibility
      })
      .catch(() => {
        commit('SET_MENU_VISIBILITY', {})
        return {}
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
